import { ColumnType } from '../utils/type';
import Tooltip from '../../forms/tooltip.component';

interface HeadProps<T> {
  columns: ColumnType<T>[];
  sortConfig?: { columnIndex: number; direction: 'asc' | 'desc' };
  onSort: (index: number) => void;
  filters: string[];
  onFilterChange?: (index: number, value: string) => void;
}

export function Head<T>({ columns, sortConfig, onSort, filters, onFilterChange }: HeadProps<T>) {
  const renderSortIcon = (index: number) => {
    const isActive = sortConfig?.columnIndex === index;
    const direction = isActive ? sortConfig?.direction : null;

    const activeColor = '#1B5451';
    const inactiveColor = 'rgba(27, 84, 81, 0.2)';

    return (
      <div
        className="d-flex flex-column align-items-center ms-1"
        style={{ lineHeight: '0', gap: '0px' }}
      >
        <i
          className="ki-duotone ki-up fw-bolder fs-3"
          style={{
            color: isActive && direction === 'asc' ? activeColor : inactiveColor,
            fontSize: '8px',
            marginBottom: '-10px'
          }}
        />
        <i
          className="ki-duotone ki-down fw-bolder fs-3"
          style={{
            color: isActive && direction === 'desc' ? activeColor : inactiveColor,
            fontSize: '8px',
            marginTop: '1px'
          }}
        />
      </div>
    );
  };

  return (
    <thead className="thead-light bg-dtt sticky-top z-index-1">
      <tr className="text-start text-dark fw-bolder fs-5">
        {columns.map((column, idx) => (
          <th
            key={idx}
            scope="col"
            className={`${column.center ? 'column-center' : ''} ${
              column.sortable ? 'cursor-pointer' : ''
            }`}
            style={{
              width: column.width ? `${column.width}%` : 'auto',
              minWidth: column.width ? `${column.width}%` : '150px',
              maxWidth: column.width ? `${column.width}%` : '200px',
              whiteSpace: 'nowrap',
              verticalAlign: 'top'
            }}
            onClick={() => column.sortable && onSort(idx)}
          >
            <div className="d-flex flex-column align-items-stretch">
              <div className="d-flex align-items-center justify-content-between">
                {column.tooltip ? (
                  <Tooltip
                    title={column.tooltip}
                    className={column.center ? 'column-text-center' : ''}
                  >
                    {column.name}
                  </Tooltip>
                ) : (
                  <span className={column.center ? 'column-text-center' : ''}>{column.name}</span>
                )}
                {column.sortable && renderSortIcon(idx)}
              </div>

              {column.filterColumn && onFilterChange && (
                <input
                  type="text"
                  value={filters[idx] || ''}
                  onClick={(e) => e.stopPropagation()}
                  onChange={(e) => onFilterChange(idx, e.target.value)}
                  placeholder="Filtrar"
                  className="form-control form-control-solid rounded-12 mt-4 filter-input"
                />
              )}
            </div>
          </th>
        ))}
      </tr>
    </thead>
  );
}
